<template>
  <account-modal class="restore-account-number-modal">
    <template slot="heading">Restore IBAN {{ accountNumber }} ({{ channel | channel }})?</template>

    <template slot="actions">
      <v-btn
        class="t-restore-button"
        color="light-blue darken-3"
        flat
        :disabled="loading"
        @click="onRestoreButtonClick"
      >restore</v-btn>

      <v-btn
        class="t-restore-cancel-button"
        color="light-blue darken-3"
        flat
        @click="onCancelButtonClick"
      >cancel</v-btn>
    </template>
  </account-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_ACCOUNT_UPDATE } from '@/events/accounts'
  import { EVENT_PROFILE_CUSTOMER_UPDATE } from '@/events/profileCustomers'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import AccountApi from '@/services/Api/AccountApi'

  // Component
  import AccountModal from '@/components/accounts/AccountModal'

  export default {
    name: 'RestoreAccountNumberModal',
    components: {
      AccountModal
    },
    data () {
      return {
        accountNumberRestoreApiRequest: new ApiRequest(AccountApi.restoreAccountNumber)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      accountId () {
        return this.modal.data.accountId
      },
      accountNumber () {
        return this.modal.data.accountNumber
      },
      channel () {
        return this.modal.data.channel
      },
      loading () {
        return this.accountNumberRestoreApiRequest.loading
      },
      error () {
        return this.accountNumberRestoreApiRequest.error
      },
      profileId () {
        return this.modal.data.profileId || null
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onRestoreButtonClick () {
        this.restoreAccountNumber()
          .then(() => {
            if (this.profileId) {
              this.$eventHub.$emit(EVENT_ACCOUNT_UPDATE, this.profileId)
            }
            this.$eventHub.$emit(EVENT_PROFILE_CUSTOMER_UPDATE)
            this.closeModal()

            setTimeout(() => {
              this.showModal({
                name: 'SuccessFlashModal',
                data: { message: 'IBAN has been successfully restored.' }
              })
            }, 100)
          })
          .catch(() => {})
      },
      onCancelButtonClick () {
        this.closeModal()
      },
      restoreAccountNumber () {
        return this.accountNumberRestoreApiRequest.execute(this.accountId, {
          accountNumber: this.accountNumber
        })
      }
    }
  }
</script>
